import Axios from 'axios';
import { Storage } from './storage';

let kiosk_endpoint = window.location.hostname.split('.')[0];
let kiosk_tld = window.location.hostname.split('.').slice(-1).join('.');

export class ApiService {

    static instance = Axios.create({
        baseURL: (
            process.env.NODE_ENV === 'production'
            ? 'https://' + (kiosk_endpoint === 'kiosk-beta' ? 'beta' : kiosk_endpoint) + '.booqi.me/api'
            : 'https://beta.booqi.me/api'
        ),
        maxRedirects: 3
    });

    static setInstance(instance) {
        this.instance = instance;
    }

    static addHeader(header, value) {
        const instance = this.instance;
        instance.defaults.headers.common[header] = value;
        this.setInstance(instance);
    }

    static setLanguage(language) {
        const cleaned = String(language || '').trim().toLowerCase();
        const instance = this.instance;

        if (cleaned) {
            instance.defaults.headers.common['Accept-Language'] = cleaned;
            this.language = cleaned;
        } else {
            delete instance.defaults.headers.common['Accept-Language'];
            this.language = null;
        }

        this.setInstance(instance);
    }

    static getLanguage() {
        return this.language || null;
    }

    static mergeLanguageConfig(config = {}, language = this.language) {
        const cleaned = String(language || '').trim().toLowerCase();

        if (!cleaned) {
            return config;
        }

        return {
            ...config,
            headers: {
                ...(config.headers || {}),
                'Accept-Language': cleaned
            },
            params: {
                ...(config.params || {}),
                language: cleaned
            }
        };
    }

    static getEndpoint() {
        return kiosk_endpoint;
    }

    static getTld() {
        return kiosk_tld;
    }

}

ApiService.language = Storage.getLanguage();
ApiService.setLanguage(ApiService.language);
